import ReceiptDetail from "./receiptDetail";

export default ReceiptDetail;
